import { VisitorEvent } from './../models/visitor.event';
import { EventTimeService } from './../../event-calendar/services/event.time.service';
import { environment } from './../../../../environments/environment';
import { Injectable } from '@angular/core';
import { ConfigService } from 'src/app/common/services/config/config.service';

@Injectable({
  providedIn: 'root',
})
export class ShareService {
  constructor(private _eventTimeService: EventTimeService) {}

  public toMailableEvent(hubName: string, item: VisitorEvent, currentUrl?: string): string {
    let description = item.description || '';
    description = this.stripHtml(description).replace(/\s+/g, ' ').trim();

    const words = description.split(' ');
    if (words.length > 90) description = words.slice(0, 90).join(' ') + '…';

    const title = (item.name || item.title || '').replace(/&/g, 'and');
    const startTime = this._eventTimeService.formatToShareTime(item.startTime);
    const organiser = item.owner.name || '';
    const link = currentUrl || this.getEventUrl(hubName, item);

    const bodyText = [
      description,
      '',
      `Start at: ${startTime}`,
      `Organizer: ${organiser}`,
      '',
      link,
    ].join('\n');

    const mailto =
      'mailto:' + `?subject=${encodeURIComponent(title)}` + `&body=${encodeURIComponent(bodyText)}`;

    return mailto;
  }

  public toMailablePlace(hubName: string, item: VisitorEvent, currentUrl?: string): string {
    /* ----------  CLEAN DESCRIPTION  ---------- */
    let description = this.stripHtml(item.description || item.title || '')
      .replace(/\s+/g, ' ') // collapse whitespace
      .trim();

    const words = description.split(' ');
    if (words.length > 90) description = words.slice(0, 90).join(' ') + '…';

    /* ----------  OTHER TEXT FIELDS  ---------- */
    const name = (item.name || item.title || '').replace(/&/g, 'and');
    const category = (item.category || '').replace(/&/g, 'and');
    const address = ((item.address?.address ?? item.address) || '').toString().replace(/&/g, 'and');

    const link = currentUrl || window.location.href;

    /* ----------  PLAIN‑TEXT BODY  ---------- */
    const bodyText = [
      description,
      '',
      `Category: ${category}`,
      `Address:  ${address}`,
      '',
      link,
    ].join('\n');

    /* ----------  BUILD ENCODED mailto: HREF  ---------- */
    const mailto =
      'mailto:' + `?subject=${encodeURIComponent(name)}` + `&body=${encodeURIComponent(bodyText)}`;

    return mailto;
  }

  public getEventUrl(hubName, item: any) {
    let url = environment.serverDomain;
    url = `${url}/${hubName}/events/details/${item._id}`;
    //url = url.substring(0, url.lastIndexOf('/')) + '/events/' + item._id;
    return url;
  }

  public stripHtml(source: string): string {
    return source.replace(/<[^>]*>/g, ''); // very simple tag stripper
  }
}
